<template>
  <div>
    <label
      :class="'subtitle-2 gray70--text d-inline-flex ' + labelPosition"
      :for="idElement"
      v-if="labelText"
    >
      {{ labelText }}
    </label>
    <v-text-field
      v-on="$listeners"
      v-bind="defaultConfigs"
      :id="idElement"
      class="base-form-input"
    />
  </div>
</template>
<script lang="ts">
const defaultProp = {
  outlined: true,
  class: "mt-2 body-2 black--text base-form-input__content",
  dense: true,
  "background-color": "white",
};
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class BaseFormInput extends Vue {
  @Prop(String) idElement: string;
  @Prop(String) labelText: string;
  @Prop({ default: "justify-start" }) labelPosition: string;
  get defaultConfigs(): any {
    return {
      ...this.$attrs,
      ...this.$props,
      ...defaultProp,
    };
  }
}
</script>
<style lang="sass">
.base-form-input__
  &content
    fieldset
      border: 1px solid rgba(0, 0, 0, .23) !important
      border-radius: 8px !important
  &content.v-input--is-disabled
    fieldset
      border: 1px solid rgba(0, 0, 0, .23) !important
      border-radius: 8px !important
      background: var(--v-gray5-base) !important
  &eye
    float: right
  &button
    min-width: 20px !important
    height: 14px !important
    padding: 0 !important
  &no-error
    .v-text-field__details
      display: none !important
</style>
